// extracted by mini-css-extract-plugin
export var carrierIcon = "_uu-0";
export var carrierLogo = "_uu-1";
export var detailsSection = "_uu-2";